import { Fragment } from "react";
import styles from "@/styles/Home.module.scss";

export function SkeletonGrid({ count }: { count: number }) {
	return (
		<>
			{Array.from({ length: count }).map((_, index) => (
				<Fragment key={"skeleton-fragment-" + index}>
					{/* Artikel Skeleton */}
					<div className={`${styles.item} ${[4, 5].includes(index) ? styles.featured : ""} ${styles.skeleton}`}>
						<div className="skeleton-image" />
					</div>
				</Fragment>
			))}
		</>
	);
}
